'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var truncateOptionsShape = _react.PropTypes.shape({
  desiredLength: _react.PropTypes.number,
  softTruncate: _react.PropTypes.bool,
  showEllipsis: _react.PropTypes.bool
});

exports.default = truncateOptionsShape;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/bc-prop-types/lib/components/truncateOptionsShape.js
// module id = 365
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15